import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CtaButton({ testId, className = "items-start" }) {
  return (
    <div data-testid={testId} className={`flex flex-col ${className}`}>
      <Link to="/contacto" data-testid={`${testId}-button`} className="btn-primary">
        Agendar una llamada de 15 minutos
        <ArrowRight className="w-4 h-4" />
      </Link>
      <p className="mt-2 text-sm text-slate-500">Sin costo. Sin compromiso.</p>
    </div>
  );
}
